import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Circle =
/** @class */
function (_super) {
  __extends(Circle, _super);

  function Circle(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.CIRCLE,
      style: __assign({
        r: 0,
        anchor: [0.5, 0.5],
        lineWidth: 0
      }, style)
    }, rest)) || this;
  }

  return Circle;
}(DisplayObject);

export { Circle };